<script setup>
import { onMounted, ref, getCurrentInstance } from "vue";
import AlocarTarefasparaequipe from "@/components/tarefas/AlocarTarefasparaequipe.vue";
import CordenadorEquipe from "@/components/tarefas/CordenadorEquipe.vue";
import { formatarEnum } from "@/utils/FormatarEntradas";
import router from "@/router";
import FormCadastroTarefa from "@/components/tarefas/FormCadastroTarefa.vue";
import { useRoute } from "vue-router";
import Carregamento from "@/components/common/Carregamento.vue";

const route = useRoute();

const carregando = ref(false);

const equipeAcao = ref([]);
const tarefasAcao = ref([]);
const TarefaAct = ref(false);
const { proxy } = getCurrentInstance();
const menuativado = ref(false);
const monstrarSelecao = ref(null);
const equipe = ref(false);
const acoes = ref("");
const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});
async function carregarEquipes(acao) {
  try {
    const response = await proxy.$api.get(`/acoes/membros-time/${acao}`);
    equipeAcao.value = response.data;
  } catch (err) {
    console.log(err);
  }
}
async function carregarTarefas(acao) {
  try {
    const response = await proxy.$api.get(`/tarefa`, {
      params: {
        page: 0,
        size: 1000,
      },
    });
    tarefasAcao.value = response.data.content;
    TarefaAct.value = true;
  } catch (err) {
    console.log(err);
  }
}

function cadastrarTarefa() {
  router.push({
    query: {
      modal: "cadastrar-tarefa",
    },
  });
}

onMounted(async () => {
  carregando.value = true;
  await carregarEquipes(props.acaoId);
  await carregarTarefas(props.acaoId);
  carregando.value = false;
});
</script>

<template>
  <section
    class="tabela"
    v-if="acoes !== 'equipe' && acoes !== 'tarefa'"
  >
    <div class="cabecalho-tabela">
      <h4>Lista de tarefas</h4>
      <div class="btn-cadastro-central-coord">
        <button @click="cadastrarTarefa()">Cadastrar tarefa</button>
      </div>
    </div>
    <Carregamento
      v-if="carregando"
      :mensagemCarregamento="'carregando tarefas'"
    />
    <div
      class="listagem-central-coordenacao"
      v-else
    >
      <div class="grid-tabela-cc cabecalho-container">
        <div class="coluna-cabecalho">Nome</div>
        <div class="coluna-cabecalho">Atvidade Vinculada</div>
        <div class="coluna-cabecalho">Prioridade</div>
        <div class="coluna-cabecalho">Status</div>
        <div class="coluna-cabecalho"></div>
      </div>

      <div class="itens-cc">
        <div
          class="item-container-cc"
          v-for="tarefa in tarefasAcao"
          :key="tarefa.id"
          :class="{
            'item-selecionado-cc':
              menuativado === tarefa.id || monstrarSelecao === tarefa.id,
          }"
        >
          <div class="grid-tabela-cc item-cc">
            <div class="celula-cc">{{ tarefa.titulo }}</div>
            <div class="celula-cc">
              {{
                tarefa.atividadeNome ? formatarEnum(tarefa.atividadeNome) : "--"
              }}
            </div>
            <div class="celula-cc">
              {{ formatarEnum(tarefa.prioridadeDescricao) }}
            </div>
            <div class="celula-cc status">
              <p>{{ formatarEnum(tarefa.statusDescricao) }}</p>
            </div>
            <div
              class="celula-cc btn-celula-cc"
              @click="
                menuativado === tarefa.id
                  ? (menuativado = null)
                  : (menuativado = tarefa.id)
              "
              @mouseenter="monstrarSelecao = tarefa.id"
              @mouseout="monstrarSelecao = null"
            >
              Ações
            </div>
          </div>
          <div
            class="menu-item-selecionado-cc"
            v-if="menuativado === tarefa.id"
          >
            <div
              class="acoes-item-selecionado"
              @click="((equipe = props.acaoId), (acoes = 'equipe'))"
            >
              Gestao de Equipe
            </div>
            <div
              class="acoes-item-selecionado"
              @click="acoes = 'tarefa'"
            >
              Alocar tarefas
            </div>
            <div
              class="acoes-item-selecionado"
              @click="acoes = ''"
            >
              Equipe
            </div>
            <div
              class="acoes-item-selecionado"
              @click="acoes = ''"
            >
              Equipe
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <RouterView />
  <FormCadastroTarefa
    v-if="route.query.modal === 'cadastrar-tarefa'"
    :acaoId="props.acaoId"
  />

  <CordenadorEquipe
    v-if="acoes == 'equipe'"
    :equipeAcao="equipeAcao.length !== 0 ? equipeAcao : null"
    @fechar-tela="acoes = ''"
  ></CordenadorEquipe>
  <AlocarTarefasparaequipe
    v-if="acoes == 'tarefa'"
    :tarefas="tarefasAcao"
    :equipeAcao="equipeAcao"
    @fechar-tela="acoes = ''"
  ></AlocarTarefasparaequipe>
</template>

<style scoped>
.status p {
  background-color: rgba(33, 150, 243, 0.3);
}
</style>
